export function resolveEmailBuilderFieldMergeTagInput(
  trigger: HTMLButtonElement | null,
): HTMLInputElement | HTMLTextAreaElement | null {
  if (trigger === null) {
    return null;
  }

  const fieldRoot = trigger.closest(".ui-input_input");
  if (!(fieldRoot instanceof HTMLElement)) {
    return null;
  }

  const candidate = fieldRoot.querySelector("input, textarea");
  if (candidate instanceof HTMLInputElement || candidate instanceof HTMLTextAreaElement) {
    return candidate;
  }

  return null;
}

export function insertEmailBuilderFieldMergeTagAtSelection(args: {
  trigger: HTMLButtonElement | null;
  value: string;
  token: string;
}): { nextValue: string; caret: number } {
  const { trigger, value, token } = args;
  const input = resolveEmailBuilderFieldMergeTagInput(trigger);

  if (input !== null && document.activeElement === input) {
    const start = input.selectionStart ?? value.length;
    const end = input.selectionEnd ?? value.length;
    const nextValue = value.slice(0, start) + token + value.slice(end);
    return { nextValue, caret: start + token.length };
  }

  const nextValue = `${value}${token}`;
  return { nextValue, caret: nextValue.length };
}

export function focusEmailBuilderFieldMergeTagInputCaret(
  trigger: HTMLButtonElement | null,
  caret: number,
): void {
  const input = resolveEmailBuilderFieldMergeTagInput(trigger);
  if (input === null) {
    return;
  }

  window.requestAnimationFrame(() => {
    input.focus();
    input.setSelectionRange(caret, caret);
  });
}
